export default __webpack_public_path__ + "static/media/passport.12c73ee2.svg";